import styled, { css } from 'styled-components';
import { colors, fontFamily } from 'components/styles/_variables';

export const StyledSelectIcon = styled.img`
  width: 16px;
  height: 16px;
  // Wrong icon
  transform: rotate(270deg);
  transition: .3s ease all;
`;

export const SelectDropdown = styled.div`
  position: absolute;
  right: 5px;
  top: 5px;
  width: 34px;
  height: calc(100% - 10px);
  background-color: ${colors.theme.action};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;
  pointer-events: none;
  ${({ variant }) => variant === 'left' && css`
    left: 5px;
    right: unset;
  `}
  ${({ variant }) => variant === 'right' && css`
    img {
      transform: rotate(90deg);
    }
  `}
`;

export const StyledSelectV2 = styled.select`
  position: relative;
  z-index: 2;
  height: ${({ selectHeight = 44 }) => `${selectHeight}px`};
  width: 100%;
  min-width: 0;
  border-radius: 6px;
  border: solid 0.5px ${({ failed }) => failed ? colors.theme.danger : colors.elements.primary};
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: '';
  padding: 16px 48px 4px 12px;
  font-family: ${fontFamily.primary};
  font-size: ${({ fontSize = 16 }) => `${fontSize}px`};
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: -0.27px;
  color: #636262;
  background-color: #ffffff;
  opacity: ${({ disabled }) => disabled ?  '0.5' : '1'};
  cursor: ${({ disabled }) => disabled ?  'not-allowed' : 'pointer'};
`;

export const StyledOptionV2 = styled.option`
  margin: 0;
  padding: 12px 10px 5px 10px;
  font-family: ${fontFamily.primary};
  font-size: 16px;
  font-weight: 600;
  line-height: 2.13;
  letter-spacing: -0.27px;
  color: #636262 !important;
`;